import { render, staticRenderFns } from "./deductionList-safe.vue?vue&type=template&id=741c1777&scoped=true"
import script from "./deductionList-safe.vue?vue&type=script&lang=js"
export * from "./deductionList-safe.vue?vue&type=script&lang=js"
import style0 from "./deductionList-safe.vue?vue&type=style&index=0&id=741c1777&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c1777",
  null
  
)

export default component.exports